//  ----------      START   IMPORT  BLOCK       ----------
import APIService from '../Core/APIService';
//  ----------      END   IMPORT  BLOCK       ----------

export default class SearchMedicService extends APIService {
  /**
   * Search medics with dynamic filter parameters
   * @param {Object} params 
   * @param {string} [params.query] 
   * @param {string} [params.speciality] - PydanticObjectId string
   * @param {Array<string>} [params.skill_ids] - List of PydanticObjectId strings
   * @param {number} [params.skip=0] 
   * @param {number} [params.limit=10] 
   */
  async searchMedic({ query, speciality, skill_ids, skip = 0, limit = 10 } = {}) {
    const queryParams = new URLSearchParams();

    if (query?.trim()) queryParams.append('query', query.trim());
    if (speciality) queryParams.append('speciality', speciality);
    
    if (Array.isArray(skill_ids) && skill_ids.length > 0) {
      skill_ids.forEach((id) => queryParams.append('skill_ids', id));
    }

    queryParams.append('skip', skip.toString());
    queryParams.append('limit', limit.toString());

    return this.get(`/search/medic?${queryParams.toString()}`);
  }
}